import React from 'react';
import { MEDIA_GALLERY_SCRIPT_URL } from 'components/MediaGallery/constants';
import { makeFinalURL } from 'components/MediaGallery/utils';

export interface MediaGalleryProps {
    dealerId: string
    dealerURL: string

    allowMultipleSelection?: boolean

    onImageSelected?: (imageURL: string) => void
    onImageDeSelected?: (imageURL: string) => void

    onMediaGalleryClose?: (imageURLs: string[]) => void
}

export const MediaGallery = (props: MediaGalleryProps) => {
    const selectedImageUrls = React.useRef<string[]>([]);

    const divRef = React.useRef() as any;

    React.useEffect(() => {
        const IdentityConfig = {
            authority: process.env.REACT_APP_DS_IGNITION_AUTHORITY,
            client_id: process.env.REACT_APP_DS_IGNITION_CLIENT_ID,
            redirect_uri: process.env.REACT_APP_DS_IGNITION_REDIRECT_URI,
            silent_redirect_uri: `${process.env.REACT_APP_DS_IGNITION_REDIRECT_URI}?silent`,
            response_type: "id_token token",
            scope: "openid dealeron.powertrain.dealerinfo.read",
            post_logout_redirect_uri: process.env.REACT_APP_DS_IGNITION_REDIRECT_URI,
            accessTokenExpiringNotificationTime: 60 * 42,
        };
        (window as any).IdentityConfig = IdentityConfig;
    }, [])

    React.useEffect(() => {
        if (divRef.current) {
            const script = document.createElement('script');
            script.onload = jsLoaded
            script.src = MEDIA_GALLERY_SCRIPT_URL;
            document.head.appendChild(script);
            return () => {
                document.head.removeChild(script);
            }
        }

    }, []);

    React.useEffect(() => {
        window.addEventListener('MediaGalleryPickedMedia', onImageSelected)
        window.addEventListener('MediaGalleryDeselectedMedia', onImageDeSelected)
        window.addEventListener('MediaGalleryClosed', onClose)
        return () => {
            window.removeEventListener('MediaGalleryPickedMedia', onImageSelected)
            window.removeEventListener('MediaGalleryDeselectedMedia', onImageDeSelected)
            window.removeEventListener('MediaGalleryClosed', onClose)
        }

    }, []);

    return (
        <div ref={divRef}>
            <div id="mediaGalleryPlugin" data-dealer-id={`${props.dealerId}`} data-enable-multiselect={props.allowMultipleSelection ?? "false"} data-in-other-slideout="false">
            </div>
        </div>
    )

    function jsLoaded() {
        window.dispatchEvent(new CustomEvent('MediaGalleryOpen'))
    }

    function onImageSelected(e:any) {        
        const imageURL = makeFinalURL(e.detail, props.dealerId, props.dealerURL)
        

        if (props.allowMultipleSelection) {
            selectedImageUrls.current = [...selectedImageUrls.current, imageURL]
        } else {
            selectedImageUrls.current = [imageURL];
        }

        if (props.onImageSelected) {
            props.onImageSelected(imageURL);
        }

    }

    function onImageDeSelected(e:any) {
        const imageURL = makeFinalURL(e.detail, props.dealerId, props.dealerURL)
        if (props.allowMultipleSelection) {
            selectedImageUrls.current = [...selectedImageUrls.current.filter(i => i !== imageURL)];
        }
        if (props.onImageDeSelected) {
            props.onImageDeSelected(imageURL)
        }
    }

    function onClose(e:any) {
        if (props.onMediaGalleryClose) {
            props.onMediaGalleryClose(selectedImageUrls.current);
        }
    }
}
